import { render } from "./BlankForms.vue?vue&type=template&id=0798de48&scoped=true"
import script from "./BlankForms.vue?vue&type=script&lang=js"
export * from "./BlankForms.vue?vue&type=script&lang=js"

import "./BlankForms.vue?vue&type=style&index=0&id=0798de48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0798de48"]])

export default __exports__